import { THarvestExportHeadersDictionary } from 'Features/localization/lang/types/exportPages';
import harvestCategoryString from 'Models/harvest/harvestCategoryString';
import harvestCommentString from 'Models/harvest/harvestCommentString';
import harvestCrewString from 'Models/harvest/harvestCrewString';
import harvestFieldsNameString from 'Models/harvest/harvestFieldsNameString';
import harvestStandardDateString from 'Models/harvest/harvestStandardDateString';
import harvestVariety from 'Models/harvest/harvestVariety';
import harvestVolume from 'Models/harvest/harvestVolume';
import harvestWeight from 'Models/harvest/harvestWeight';
import harvestWeightUnit from 'Models/harvest/harvestWeightUnit';

import { TPartnerHarvest } from '../types';

export type THarvestExportData = Record<string, string | number>;

function getHarvestRowExportData(
	harvest: TPartnerHarvest,
	dictionary: THarvestExportHeadersDictionary
): THarvestExportData {
	const {
		date,
		field,
		location,
		category,
		variety,
		boxes,
		weight,
		weightUnit,
		responsible,
		quality,
		comment,
	} = dictionary;

	const baseRowData = {
		[date]: harvestStandardDateString(harvest),
		[location]: harvest.location.name || '-',
		[field]: harvestFieldsNameString(harvest),
		[category]: harvestCategoryString(harvest),
		[variety]: harvestVariety(harvest),
		[boxes]: harvestVolume(harvest),
		[weight]: harvestWeight(harvest),
		[weightUnit]: harvestWeightUnit(harvest),
		[responsible]: harvestCrewString(harvest),
		[quality]: harvest.quality,
		[comment]: harvestCommentString(harvest),
	};

	return baseRowData;
}

export default getHarvestRowExportData;
